<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'AvContractJobContentForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.subjectOfContract')" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.subjectOfContract"
              label="Vertragsgegenstand"
              class="caption"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasThirdPartyCountryTransfer')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasThirdPartyCountryTransfer"
              label="Es findet eine Datenübertragung in ein Drittland statt."
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex
            v-if="isFieldVisible('avContract.thirdCountryName')
            && avContract.hasThirdPartyCountryTransfer == 1"
            xs12 md6
            py-0
          >
            <v-text-field
              v-model="avContract.thirdCountryName"
              label="Name des Drittlandes"
              height="22"
              class="caption"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex
            v-if="isFieldVisible('avContract.hasAdequacyDecision')
            && avContract.hasThirdPartyCountryTransfer == 1"
            xs12 md6
            py-0
          >
            <!-- eslint-disable -->
            <v-checkbox
              v-model="avContract.hasAdequacyDecision"
              label="ist festgestellt durch einen Angemessenheitsbeschluss der Kommission (Art. 45 Abs. 3 DS-GVO)"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasDataProtectionRegulations') && avContract.hasThirdPartyCountryTransfer == 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasDataProtectionRegulations"
              label="wird hergestellt durch verbindliche interne Datenschutzvorschriften (Art. 46 Abs. 2 lit. b i.V.m. 47 DS-GVO)"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasStandardProtectionClauses') && avContract.hasThirdPartyCountryTransfer == 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasStandardProtectionClauses"
              label="wird hergestellt durch Standarddatenschutzklauseln (Art. 46 Abs. 2 litt. c und d DS-GVO)"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasBehaviorRules') && avContract.hasThirdPartyCountryTransfer == 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasBehaviorRules"
              label="wird hergestellt durch genehmigte Verhaltensregeln (Art 46 Abs. 2 lit. e i.V.m. 40 DS-GVO)"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasCertMechanism') && avContract.hasThirdPartyCountryTransfer == 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasCertMechanism"
              label="wird hergestellt durch einen genehmigten Zertifizierungsmechanismus (Art. 46 Abs. 2 lit. f i.V.m. 42 DS-GVO)"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasOtherMeasures') && avContract.hasThirdPartyCountryTransfer == 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasOtherMeasures"
              label="wird hergestellt durch sonstige Maßnahmen (Art. 46 Abs 2 lit. a, Abs. 3 litt. a und b DS-GVO)"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.otherMeasures') && avContract.hasThirdPartyCountryTransfer == 1 && avContract.hasOtherMeasures == 1" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.otherMeasures"
              label="sonstige Maßnahmen"
              class="caption"
            />
          </v-flex>
        </v-layout>
            <!-- eslint-enable -->
      </v-flex>
    </v-layout>
  </div>
</template>
